import { createValidator } from "@plugins/text-field";

export const decimalValidators = [
    createValidator({
      name: "decimalValidation",
      validatorFn: (value)=>{
        if(value==''){
            return true
        }
        const doesContainDecSymbol =  value.includes(".") || value.includes(",");
        const isFloatingValue = parseFloat(value) && parseFloat(value) % 1 !== 0;
    
        console.log("::{}:: CUSTOM VALIDATOR",value)
    
        return isFloatingValue || doesContainDecSymbol
    
    },
      errorMessage: "Must be a valid Decimal",
    }),
  ]



  export const intValidators = [
    createValidator({
      name: "intValidation",
      validatorFn: (value)=>{
        if(value==''){
            return true
        }

        const intRegex = /^-?\d+$/;
       
        const isIntValue = intRegex.test(value) ;
    
        console.log("::{}:: CUSTOM VALIDATOR INT",value)
    
        return isIntValue
    
    },
      errorMessage:  "Must be a valid Integer",
    }),
  ]


  export const emailValidators = [
    createValidator({
      name: "emailValidation",
      validatorFn: (value)=>{
        if(value==''){
            return true
        }

        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        const isEmailValue = emailRegex.test(value) ;
    
        console.log("::{}:: CUSTOM VALIDATOR Email",value)
    
        return isEmailValue
    
    },
      errorMessage:   "Must be a valid Email",
    }),
  ]



// export const checkIsFloat = (value)=>{
//     const doesContainDecSymbol =  value.includes(".") || value.includes(",");
//     const isFloatingValue = parseFloat(value) && parseFloat(value) % 1 !== 0;

//     console.log("::{}:: CUSTOM VALIDATOR",value)

//     return isFloatingValue || doesContainDecSymbol

// }